import { render } from "./ClickAnimationEditor.vue?vue&type=template&id=2f01f966&scoped=true"
import script from "./ClickAnimationEditor.vue?vue&type=script&lang=ts"
export * from "./ClickAnimationEditor.vue?vue&type=script&lang=ts"

import "./ClickAnimationEditor.vue?vue&type=style&index=0&id=2f01f966&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f01f966"

export default script